var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "whatsapp-v1-channels" } },
    [
      _c("AppBreadCrumb", {
        attrs: {
          paths: [{ title: _vm.$t("whatsappChannel.whatsappTitleV1") }],
          select: true,
        },
      }),
      _vm._v(" "),
      _vm.showUpgrade
        ? _c(
            "UpgradeNeeded",
            {
              on: {
                close: function ($event) {
                  _vm.showUpgrade = false
                },
                "show-plans": _vm.showWhatsappPlans,
              },
            },
            [
              _vm.maxWhatsappChannel <= 0
                ? _c("div", [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("whatsapp.needWhatsappPackage")) +
                        "\n        "
                    ),
                  ])
                : _c("div", [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.$t("whatsapp.channelLimitReached", {
                            max: _vm.maxWhatsappChannel,
                          })
                        ) +
                        "\n        "
                    ),
                  ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "d-flex right-page",
          staticStyle: { "background-color": "#ffffff" },
        },
        [
          _c(
            "div",
            { staticClass: "ml-3 mt-3", staticStyle: { flex: "0 0 100%" } },
            [
              _c("div", { staticClass: "big-title" }, [
                _vm._v(_vm._s(_vm.$t("whatsappChannel.whatsappTitleV1"))),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "channels" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "story channel-add",
                      on: { click: _vm.createChannel },
                    },
                    [
                      _c("a-icon", {
                        staticStyle: { "font-size": "30px" },
                        attrs: { type: "plus-circle", theme: "filled" },
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "text-large font-weight-bolder mt-2",
                          staticStyle: {
                            "font-size": "20px",
                            "letter-spacing": "2px",
                          },
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("whatsappChannel.addChannel")) +
                              "\n                    "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.channels, function (channel, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "channel-item",
                        class: [!channel.enabled && "disabled"],
                        on: {
                          click: function () {
                            return channel.enabled && _vm.editChannel(channel)
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "icon-container" },
                          [_c("WhatsappIcon")],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "name-container" }, [
                          _c("span", { staticClass: "name" }, [
                            _vm._v(_vm._s(channel.name.toUpperCase())),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "phone" }, [
                            _vm._v(
                              "\n                            (" +
                                _vm._s(channel.payload.phoneNumber) +
                                ") - (" +
                                _vm._s(
                                  channel.forward.story
                                    ? "Chatbot"
                                    : "Live Agent"
                                ) +
                                ")\n                        "
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "options" },
                          [
                            _c(
                              "a-dropdown",
                              {
                                attrs: {
                                  trigger: ["click"],
                                  placement: "bottomRight",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "overlay",
                                      fn: function () {
                                        return [
                                          _c(
                                            "a-menu",
                                            [
                                              _c("a-menu-item", [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "icon-container",
                                                    on: {
                                                      click: function ($event) {
                                                        _vm.editShowCreateForm =
                                                          channel
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "md-icon",
                                                      {
                                                        staticStyle: {
                                                          "margin-right":
                                                            "10px",
                                                        },
                                                      },
                                                      [_vm._v("edit")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t("message.edit")
                                                        )
                                                      ),
                                                    ]),
                                                  ],
                                                  1
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              _c("a-menu-item", [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "icon-container",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.deleteMultiWp(
                                                          channel._id
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "md-icon",
                                                      {
                                                        staticStyle: {
                                                          "margin-right":
                                                            "10px",
                                                        },
                                                      },
                                                      [_vm._v("delete")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "chatbotv2.delete"
                                                          )
                                                        )
                                                      ),
                                                    ]),
                                                  ],
                                                  1
                                                ),
                                              ]),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "icon-container ant-dropdown-link",
                                    on: {
                                      click: function (e) {
                                        return e.stopPropagation()
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "material-icons" },
                                      [_vm._v("more_horiz")]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    )
                  }),
                ],
                2
              ),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _vm.showCreateForm
        ? _c(
            "Modal2",
            {
              attrs: {
                title: _vm.$t("whatsappChannel.newWhatsappChannel"),
                description: _vm.$t(
                  "whatsappChannel.newWhatsappChannelDescription"
                ),
                "class-name": "new-waba",
                showFooter: false,
              },
              on: {
                cancel: function ($event) {
                  _vm.showCreateForm = false
                },
              },
            },
            [
              _c("NewMultiWhatsappChannel", {
                on: {
                  cancel: function ($event) {
                    _vm.showCreateForm = false
                  },
                  ok: _vm.channelCreated,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.editShowCreateForm
        ? _c(
            "Modal2",
            {
              attrs: {
                title: _vm.$t("whatsappChannel.editWhatsappChannel"),
                description: _vm.$t(
                  "whatsappChannel.editWhatsappChannelDescription"
                ),
                "class-name": "new-waba",
                showFooter: false,
              },
              on: {
                cancel: function ($event) {
                  _vm.editShowCreateForm = false
                },
              },
            },
            [
              _c("EditMultiWhatsappChannel", {
                attrs: { channel: _vm.editShowCreateForm },
                on: {
                  cancel: function ($event) {
                    _vm.editShowCreateForm = false
                  },
                  ok: _vm.channelCreated,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: {
            visible: _vm.deleteModal,
            icon: "exclamation-circle",
            title: _vm.$t("whatsappChannel.whatsappChannel"),
          },
          on: {
            cancel: function ($event) {
              _vm.deleteModal = false
            },
          },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function () {
                return [
                  _c(
                    "a-button",
                    {
                      key: "back",
                      on: {
                        click: function ($event) {
                          _vm.deleteModal = false
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("chatbotv2.dismiss")) +
                          "\n            "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-button",
                    {
                      key: "submit",
                      attrs: { type: "danger" },
                      on: { click: _vm.deleteWhatsappChannel },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("chatbotv2.delete")) +
                          "\n            "
                      ),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c("p", [
            _vm._v(
              _vm._s(_vm.$t("whatsappChannel.deleteWhatsappChannelDescription"))
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }